import { Skeleton } from "@material-ui/lab";
import React from "react";

import { Heading } from "@/features/common/components/tailwind/Heading";
import { View } from "@/features/common/components/tailwind/View";

import { JoinSubscriptionBoxView } from "./JoinSubscriptionBoxView";

export const JoinSubscriptionPaymentViewPlaceholder: React.FC = (props) => {
  return (
    <JoinSubscriptionBoxView>
      <View className="w-full flex items-center">
        <Heading.H5 style={{ width: "100%" }}>
          <Skeleton width="40%" />
        </Heading.H5>
      </View>

      {/* options */}
      <View className="w-full h-[150px]  mb-9 flex">
        <View className="flex-1 my-4 mr-4 flex">
          <Skeleton width="100%" />
        </View>

        <View className="flex-1 my-4 flex">
          <Skeleton width="100%" />
        </View>
      </View>

      {/* confirm and previous button */}
      <View className="w-full flex justify-end min-h-[50px]">
        <View className="min-w-[120px] flex">
          <Skeleton width="100%" />
        </View>
      </View>
    </JoinSubscriptionBoxView>
  );
};
